import React, { useState } from 'react';
import { Box, Container, Grid, Typography, Link } from '@mui/material';
import { Facebook, Instagram, LinkedIn, Twitter, YouTube } from '@mui/icons-material';
import visa from '../../../assets/visa.png';
import paypal from '../../../assets/paypal.jpeg';
import mastercard from '../../../assets/mastercard.jpeg';
import Logo1 from '../../../assets/Logo1.svg';

const Footer = () => {

  return (
    <>
      {/* Footer Top */}
      <Box component="footer" bgcolor="#5190A6" py={6} px={{ xs: 4, sm: 6, lg: 8 }}>
        <Container maxWidth="lg">
          <Grid container spacing={4} justifyContent="space-between">
            <Grid item xs={18} md={9}>
              <img src={Logo1} alt="IPHRx" height={42} style={{ marginBottom: '16px' }} />
              <Typography variant="h6" color="text.secondary" style={{ color: '#ffffff', fontWeight: 'bold', marginBottom: '8px' }}>
                About / Contacts
              </Typography>
              <Typography variant="body2" color="text.secondary" style={{ color: '#ffffff' }}>
                IPH Pharmaceuticals Sdn. Bhd.<br />
                323, 1st Floor, Jalan Pudu, 55100 Kuala Lumpur, Wilayah Persekutuan , Malaysia
              </Typography>
              <Typography variant="body2" color="text.secondary" style={{ color: '#ffffff', marginTop: '8px' }}>
                iphrx7@gmail.com <br />
                shern@iphrx.com.my
              </Typography>
              <Typography variant="body2" color="text.secondary" style={{ color: '#ffffff', marginTop: '8px' }}>
                +6010-8726948<br />
                +6012-5223374
              </Typography>
              <Box mt={2}>
                <Link href="https://www.facebook.com/p/IPH-Pharmaceuticals-61567326590295/" target="_blank" color="#ffffff" mr={2}>
                  <Facebook fontSize="small" />
                </Link>
                <Link href="https://www.instagram.com/iphpharma?igsh=MXF6cGZub3g4OHB5bA==" target="_blank" color="#ffffff" mr={2}>
                  <Instagram fontSize="small" />
                </Link>
                {/* <Link href="#" color="#ffffff" mr={2}>
                  <LinkedIn fontSize="small" />
                </Link>
                <Link href="#" color="#ffffff" mr={2}>
                  <Twitter fontSize="small" />
                </Link> */}
                <Link href="https://www.youtube.com/@IPHRX" target="_blank" color="#ffffff" mr={2}>
                  <YouTube fontSize="small" />
                </Link>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box >

      {/* Footer Bottom */}
      < Box
        sx={{
          backgroundColor: '#386F82',
          padding: '10px 0',
        }
        }
      >
        <Container maxWidth="lg">
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Typography variant="body2" color="#ffffff">
              Copyright &copy; {new Date().getFullYear()} IPHRx. All Rights Reserved.
            </Typography>
            <Box
              sx={{
                display: 'flex',
                justifyContent: { xs: 'center', md: 'flex-end' },
                alignItems: 'center',
                mt: { xs: 2, md: 0 }
              }}
            >
              <Box
                display="flex"
                gap={2}
                alignItems="center"
                sx={{
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  padding: '8px 16px',
                  borderRadius: '8px',
                  backdropFilter: 'blur(10px)'
                }}
              >
                <Box display="flex" gap={1.5} alignItems="center">
                  {/* <img
                    src={paypal}
                    alt="PayPal"
                    style={{
                      height: '28px',
                      width: 'auto',
                      maxWidth: '50px',
                      objectFit: 'contain',
                      backgroundColor: '#ffffff',
                      padding: '2px 4px',
                      borderRadius: '4px',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                    }}
                  /> */}
                  <img
                    src={visa}
                    alt="Visa"
                    style={{
                      height: '28px',
                      width: 'auto',
                      maxWidth: '50px',
                      objectFit: 'contain',
                      backgroundColor: '#ffffff',
                      padding: '2px 4px',
                      borderRadius: '4px',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                    }}
                  />
                  <img
                    src={mastercard}
                    alt="Mastercard"
                    style={{
                      height: '28px',
                      width: 'auto',
                      maxWidth: '50px',
                      objectFit: 'contain',
                      backgroundColor: '#ffffff',
                      padding: '2px 4px',
                      borderRadius: '4px',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                    }}
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        </Container>
      </Box >
    </>
  );
};

export default Footer;
